<script lang="ts" setup>
/**
 * UiHeadingSection — Increases the heading level for all descendants.
 *
 * Wrap content in this component to create a sub-section where all
 * <UiHeading> components render one level deeper.
 *
 * @example
 * <UiHeading>Page Title</UiHeading>           <!-- h1 -->
 * <UiHeading>Section A</UiHeading>            <!-- h2 -->
 * <UiHeadingSection>
 *   <UiHeading>Sub-section</UiHeading>        <!-- h3 -->
 *   <UiHeadingSection>
 *     <UiHeading>Deep section</UiHeading>     <!-- h4 -->
 *   </UiHeadingSection>
 * </UiHeadingSection>
 */
const { disabled = false } = defineProps<{ disabled?: boolean }>()

if (!disabled) {
  provideHeadingSectionContext()
}
</script>

<template>
  <slot />
</template>
